<template>
    <ion-content main>
        <back-arrow v-if="!noBack.find(path => path === $route.path)" />
        <router-view />
    </ion-content>
</template>

<script>
import BackArrow from '@/components/BackArrow'

export default {
    name: 'MainPage',
    components: { BackArrow },
    data() {
        return {
            noBack: ['/login', '/messages', '/register', '/']
        }
    }
}
</script>
